<lib-search>
    <!-- <lib-events></lib-events> -->
    <!-- <lib-exhibit-carousel></lib-exhibit-carousel> -->
    <!-- <lib-buffer [bufferHeight]="16"></lib-buffer>    <lib-collections></lib-collections> -->
    <!-- <lib-buffer [bufferHeight]="16"></lib-buffer> -->
    <!-- <lib-games-carousel></lib-games-carousel>
    <lib-buffer [bufferHeight]="16"></lib-buffer> -->
    <lib-collection-multi-carousel></lib-collection-multi-carousel>
    <lib-buffer [bufferHeight]="16"></lib-buffer>
    <lib-video-carousel></lib-video-carousel>
    <lib-buffer [bufferHeight]="16"></lib-buffer>

</lib-search>